import { render, staticRenderFns } from "./BusinessCategoryForm.vue?vue&type=template&id=6b29f7c4&scoped=true"
import script from "./BusinessCategoryForm.vue?vue&type=script&lang=js"
export * from "./BusinessCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./BusinessCategoryForm.vue?vue&type=style&index=0&id=6b29f7c4&prod&lang=sass&scoped=true"
import style1 from "./BusinessCategoryForm.vue?vue&type=style&index=1&id=6b29f7c4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b29f7c4",
  null
  
)

export default component.exports